import menu from './menu';
import notifications from './notifications';
import moment from 'moment';

const currentMonthrange = moment().startOf('month').format('YYYY-MM-DD') + ',' + moment().endOf('month').format('YYYY-MM-DD');

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/news_posts': {
                params: { sort: 'available_at:desc', append: 'category_list' }
            },
            '^/staff_members': {
                params: { sort: 'position:desc', append: 'branch_list' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
            '^/customers_listings': {
                params: { filter: `datecreated:$range(${currentMonthrange})`, sort: 'datecreated:desc' }
            },
            '^/customers': {
                params: { sort: 'dateregistered:desc' }
            },
            '^/customer/[0-9]+/login_log': {
                params: { sort: 'logindate:desc' }
            },
            '^/customer/[0-9]+/notes': {
                params: { sort: 'created_at:desc' }
            },
            '^/customer/[0-9]+/applications': {
                params: { filter: 'confirmed:1', sort: 'created_at:desc' }
            },
            '^/customer/[0-9]+/alerts': {
                params: { sort: 'created_at:desc' }
            },
            '^/applications': {
                params: { sort: 'created_at:desc' }
            },
            '^/listings': {
                params: { filter: 'sold:0' }
            },
            '^/listing/[0-9]+/images': {
                params: { sort: 'position:asc', per_page: 25 }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/customer_login_logs': {
                params: { filter: `success:1;logindate:$range(${currentMonthrange})`, sort: 'logindate:desc', append: 'customer_name,email,phone' }
            },
            '^/search_log': {
                params: { filter: `created_at:$range(${currentMonthrange})`, sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
